<p-dialog [visible]="true" [breakpoints]="{'440px': '100%'}" [style]="{width: '50%'}" [baseZIndex]="10000"
  [ngClass]="{'change-scrollbar-color-darkMode': settings.darkModeSetting, 'change-scrollbar-color': !settings.darkModeSetting}" [modal]="true"
  [maximizable]="false" [draggable]="false" [resizable]="false">
  <dialog-header [title]="app.translations.GBL_lbl_SettingsText" [settings]="settings" [icon]="faGear"></dialog-header>  
  <div class="row" [ngClass]="settings.darkModeSetting ? 'bg-dark' : 'bg-white'">
    <div [ngClass]="mobileView ? 'col-12 flex' : 'col-2'" style="padding-top: 13px;">
      <div class="font14 cursorPointer animated fadeIn padding7" (click)="selectItem(1)">
        <fa-icon [icon]="faSliders" class="menu-icon" [ngClass]="settings.darkModeSetting ? 'textWhite' : 'textBlack'"></fa-icon>
        <span class="padding3 b-radius"
          [ngClass]="selectedItem == 1 ? (settings.darkModeSetting ? 'textWhite bg-dark-secondary' : 'textBlack bg-light-blue') : (settings.darkModeSetting ? 'textWhite' : 'textBlack')">
          {{app.translations.SET_lbl_PersonalisationText}}
        </span>
      </div>
      <ng-template [ngIf]="!mobileView">
        <div class="font14 cursorPointer animated fadeIn padding7" (click)="selectItem(2)">
          <fa-icon [icon]="faBorderAll" class="menu-icon" [ngClass]="settings.darkModeSetting ? 'textWhite' : 'textBlack'"></fa-icon>
          <span class="padding3 b-radius"
            [ngClass]="selectedItem == 2 ? (settings.darkModeSetting ? 'textWhite bg-dark-secondary' : 'textBlack bg-light-blue') : (settings.darkModeSetting ? 'textWhite' : 'textBlack')">
            {{app.translations.SET_lbl_GridsText}}
          </span>
        </div>
      </ng-template>
      <div class="font14 cursorPointer animated fadeIn padding7" (click)="selectItem(!mobileView ? 3 : 2)">
        <fa-icon [icon]="faUser" class="menu-icon" [ngClass]="settings.darkModeSetting ? 'textWhite' : 'textBlack'"></fa-icon>
        <span class="padding3 b-radius"
          [ngClass]="selectedItem == (!mobileView ? 3 : 2) ? (settings.darkModeSetting ? 'textWhite bg-dark-secondary' : 'textBlack bg-light-blue') : (settings.darkModeSetting ? 'textWhite' : 'textBlack')">
          {{app.translations.SET_lbl_AccountText}}
        </span>
      </div>
    </div>
    <div [ngClass]="mobileView ? 'col-12' : 'col-10'">
      <div class="settings-container">
        <ng-template [ngIf]="selectedItem == 1">
          <div class="col-12 animated fadeIn">
            <div [ngClass]="settings.darkModeSetting ? 'setting-border-dark' : 'setting-border'">             
              <span class="font14" [ngClass]="settings.darkModeSetting ? 'textWhite' : 'textBlack'">
                {{app.translations.SET_lbl_DarkModeSettingText}}
              </span>
              <mat-slide-toggle class="float-right" [(ngModel)]="settings.darkModeSetting"
                (ngModelChange)="updateDarkModeSetting($event)"></mat-slide-toggle><br><br>
              <span class="font14" [ngClass]="settings.darkModeSetting ? 'textWhite' : 'textBlack'">
                {{app.translations.SET_lbl_DarkModeMatchSettingText}}
              </span>
              <mat-checkbox class="float-right" [checked]="settings.followSystemDarkMode" (change)="followSystem($event)">
              </mat-checkbox>
            </div>
          </div>
          <div class="col-12 animated fadeIn">
            <div [ngClass]="settings.darkModeSetting ? 'setting-border-dark' : 'setting-border'">              
              <span class="font14" [ngClass]="settings.darkModeSetting ? 'textWhite' : 'textBlack'">
                {{app.translations.SET_lbl_toggleExpandMenuText}}                
              </span>
              <mat-slide-toggle class="float-right" [(ngModel)]="settings.menuToggleSetting"
                (ngModelChange)="updateMenuToggleSetting($event)"></mat-slide-toggle>
            </div>
          </div>
          <div class="col-12 animated fadeIn">
            <div [ngClass]="settings.darkModeSetting ? 'setting-border-dark' : 'setting-border'">              
              <span [ngClass]="['font' + settings.textSizeSetting, settings.darkModeSetting ? 'textWhite' : 'textBlack']">
                {{app.translations.SET_lbl_TextsizeSettingText}}                
              </span>
              <input type="number" min="10" max="22" [(ngModel)]="settings.textSizeSetting" step="1" pattern="[0-9]*"
                class="font14 float-right unset-outline b-radius padding3 unset-b"
                (ngModelChange)="updateTextSizeSetting($event)"
                [ngClass]="settings.darkModeSetting ? 'textWhite bg-dark-secondary' : 'textBlack bg-light-blue'" />
            </div>
          </div>
          <div class="col-12 animated fadeIn">
            <div [ngClass]="settings.darkModeSetting ? 'setting-border-dark' : 'setting-border'">              
              <span class="font14" [ngClass]="[settings.darkModeSetting ? 'textWhite' : 'textBlack']">
                {{app.translations.SET_lbl_ErrorInfo}}                
              </span>
              <mat-slide-toggle class="float-right" [(ngModel)]="settings.detailedErrorSetting"
                (ngModelChange)="updateDetailedErrorSetting($event)"></mat-slide-toggle>
            </div>
          </div>
          <div class="flex align-centre">
            <div class="col-12 animated fadeIn">
              <div class="relative" [ngClass]="settings.darkModeSetting ? 'setting-border-dark' : 'setting-border'">                
                <span class="font14" [ngClass]="[settings.darkModeSetting ? 'textWhite' : 'textBlack']">
                  {{app.translations.SET_lbl_DateFormatSettingText}}
                </span>
                <fa-icon [icon]="faInfoCircle" class="font14" [ngClass]="settings.darkModeSetting ? 'textWhite' : 'textBlack'"
                pTooltip="{{app.translations.SET_hint_FiltersWillBeRemoved}}" tooltipPosition="top"></fa-icon>
                <select class="font14 cursorPointer b-radius float-right"
                  [ngClass]="[settings.darkModeSetting ? 'textWhite' : 'textBlack']" (change)="updateDateFormatSetting($event)">
                  <option class="cursorPointer textBlack" [selected]="settings.dateFormatSetting == 'dd/MM/yyyy'">
                    dd/MM/yyyy
                  </option>
                  <option class="cursorPointer textBlack" [selected]="settings.dateFormatSetting == 'yyyy/MM/dd'">
                    yyyy/MM/dd
                  </option>
                  <option class="cursorPointer textBlack" [selected]="settings.dateFormatSetting == 'MM/dd/yyyy'">
                    MM/dd/yyyy
                  </option>
                </select>
              </div>
            </div>                        
          </div>
          <div class="col-12 animated fadeIn">
            <div [ngClass]="settings.darkModeSetting ? 'setting-border-dark' : 'setting-border'">              
              <span class="font14" [ngClass]="[settings.darkModeSetting ? 'textWhite' : 'textBlack']">
                Open widgets by default                
              </span>
              <mat-slide-toggle class="float-right" [(ngModel)]="settings.widgetsOpen"
                (ngModelChange)="updateWidgetsOpenSetting($event)"></mat-slide-toggle>
            </div>
          </div>
        </ng-template>
        <ng-template [ngIf]="!mobileView && selectedItem == 2">
          <div class="col-12 animated fadeIn">
            <div [ngClass]="settings.darkModeSetting ? 'setting-border-dark' : 'setting-border'">              
              <span class="font14" [ngClass]="settings.darkModeSetting ? 'textWhite' : 'textBlack'">
                {{app.translations.SET_lbl_toggleCompactText}}
              </span>
              <mat-slide-toggle class="float-right" [(ngModel)]="settings.compactGridSetting"
                (ngModelChange)="updateCompactGridSetting($event)"></mat-slide-toggle>
            </div>
          </div>
          <div class="col-12 animated fadeIn">
            <div [ngClass]="settings.darkModeSetting ? 'setting-border-dark' : 'setting-border'">              
              <span class="font14" [ngClass]="settings.darkModeSetting ? 'textWhite' : 'textBlack'">
                {{app.translations.SET_lbl_FilterSettingText}}
              </span>
              <fa-icon [icon]="faInfoCircle" class="font14" [ngClass]="settings.darkModeSetting ? 'textWhite' : 'textBlack'"
                pTooltip="{{app.translations.SET_hint_FiltersWillBeRemoved}}" tooltipPosition="top"></fa-icon>
              <mat-slide-toggle class="float-right" [(ngModel)]="settings.detailFiltersByRowSetting"
                (ngModelChange)="updateFiltersByRowSetting($event)"></mat-slide-toggle>
            </div>
          </div>
          <div class="col-12 animated fadeIn">
            <div [ngClass]="settings.darkModeSetting ? 'setting-border-dark' : 'setting-border'">            
              <span class="font14" [ngClass]="[settings.darkModeSetting ? 'textWhite' : 'textBlack']">
                {{app.translations.SET_lbl_FilterHistorySettingText}}
              </span>
              <fa-icon [icon]="faInfoCircle" class="font14" [ngClass]="settings.darkModeSetting ? 'textWhite' : 'textBlack'"
                pTooltip="{{app.translations.SET_hint_FiltersWillBeRemoved}}" tooltipPosition="top"></fa-icon>
              <mat-slide-toggle class="float-right" [(ngModel)]="settings.filterHistorySetting"
                (ngModelChange)="updateFilterHistorySetting($event)"></mat-slide-toggle>
            </div>
          </div>
          <div class="col-12 animated fadeIn">
            <div [ngClass]="settings.darkModeSetting ? 'setting-border-dark' : 'setting-border'">              
              <span class="font14" [ngClass]="settings.darkModeSetting ? 'textWhite' : 'textBlack'">
                {{app.translations.SET_lbl_FilterDelaySettingText}}
              </span>              
              <mat-slide-toggle class="float-right" [(ngModel)]="settings.filterDelaySetting"
                (ngModelChange)="updateFilterDelaySetting($event)"></mat-slide-toggle>
            </div>
          </div>
          <div class="col-12 animated fadeIn">
            <div [ngClass]="settings.darkModeSetting ? 'setting-border-dark' : 'setting-border'">              
              <span class="font14" [ngClass]="settings.darkModeSetting ? 'textWhite' : 'textBlack'">
                {{app.translations.SET_lbl_StorageManagementText}}
              </span>              
              <button class="btn float-right font14" (click)="openStorageManagement()"
                [ngClass]="settings.darkModeSetting ? 'textWhite' : 'textBlack'" style="transform: translateY(-7px);">
                {{app.translations.SET_btn_OpenStorageManagementText}}
                <fa-icon [icon]="faArrowUpRightFromSquare" class="font15 textGreen"></fa-icon>
              </button>
            </div>
          </div>
          <div class="col-12 animated fadeIn">
            <div [ngClass]="settings.darkModeSetting ? 'setting-border-dark' : 'setting-border'">              
              <span class="font14" [ngClass]="settings.darkModeSetting ? 'textWhite' : 'textBlack'">
                {{app.translations.SET_lbl_FreeGridResizingText}}
              </span>   
              <fa-icon [icon]="faInfoCircle" class="font14" [ngClass]="settings.darkModeSetting ? 'textWhite' : 'textBlack'"
                pTooltip="{{app.translations.SET_hint_FreeGridResizingText}}" tooltipPosition="top"></fa-icon>           
              <mat-slide-toggle class="float-right" [(ngModel)]="settings.freeColumnResizeSetting"
                (ngModelChange)="updateFreeColumnResizeSetting($event)"></mat-slide-toggle>
            </div>
          </div>
          <div class="col-12 animated fadeIn">
            <div [ngClass]="settings.darkModeSetting ? 'setting-border-dark' : 'setting-border'">              
              <span class="font14" [ngClass]="settings.darkModeSetting ? 'textWhite' : 'textBlack'">
                {{app.translations.SET_lbl_TextAlignmentText}}
              </span>              
              <mat-slide-toggle class="float-right" [(ngModel)]="settings.textAlignmentSetting"
                (ngModelChange)="updateTextAlignmentSetting($event)"></mat-slide-toggle>
            </div>
          </div>
          <div class="col-12 animated fadeIn">
            <div [ngClass]="settings.darkModeSetting ? 'setting-border-dark' : 'setting-border'">              
              <span class="font14" [ngClass]="settings.darkModeSetting ? 'textWhite' : 'textBlack'">
                Keep detail headers visible as you scroll
              </span>              
              <mat-slide-toggle class="float-right" [(ngModel)]="settings.stickyDetailHeadersSetting"
                (ngModelChange)="updateStickyDetailHeadersSetting($event)"></mat-slide-toggle>
            </div>
          </div>
        </ng-template>
        <ng-template [ngIf]="selectedItem == (!mobileView ? 3 : 2)">
          <div class="col-12 animated fadeIn">
            <div [ngClass]="settings.darkModeSetting ? 'setting-border-dark' : 'setting-border'">              
              <span class="font14" [ngClass]="settings.darkModeSetting ? 'textWhite' : 'textBlack'">
                <button class="textGreen bg-none unset-b unset-p" (click)="changePassword()">
                  {{app.translations.SET_btn_ChangePasswordText}}
                </button> {{app.translations.SET_btn_ChangePasswordSettingText}}
              </span>
            </div>
          </div>
        </ng-template>
      </div>
    </div>
  </div>
</p-dialog>